"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _windowUtil = _interopRequireDefault(require("01_core/logics/windowUtil"));
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _areaOrderingActions = require("./areaOrderingActions");
var _AreaOrderingSearchCondition = _interopRequireDefault(require("./components/AreaOrderingSearchCondition"));
var _AreaOrderingSearchResult = _interopRequireDefault(require("./components/AreaOrderingSearchResult"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 地域表示順設定
 */
class AreaOrderingMain extends _react.default.Component {
  constructor() {
    super(...arguments);
    // 詳細ボタン押下ハンドラ
    _defineProperty(this, "onDetailClick", kaishaCd => {
      return () => {
        this.props.goDetail(kaishaCd);
      };
    });
    /**
     * 並び変え更新後の処理
     */
    _defineProperty(this, "onSortUpdate", returnList => {
      const {
        searchResult
      } = this.props;

      // returnListから会社コードを特定
      let targetKaishaCd = returnList[0].key.split('-')[0];
      let changeInfoList = [];
      let targetAreaSortOrders;

      // 会社コードから並び替え前の地域情報を取得
      searchResult.forEach(function (res) {
        if (res.kaishaCd === targetKaishaCd) {
          targetAreaSortOrders = res.areaSortOrders; // 操作した会社に紐づく地域情報の並び順情報

          // 新たなソート順をreturnListより取得する
          targetAreaSortOrders.forEach(function (areaSortOrder, index) {
            let changeInfo = {
              tgtIdx: 0,
              newSortOrder: 0
            };
            let sortOrderingKey = areaSortOrder.sortOrderingKey; // ソート順設定KEYを保持
            let newSortOrder = 0; //　並び替え後のソート順
            returnList.forEach(function (ret) {
              if (ret.key === sortOrderingKey) {
                // ソート順設定KEYと一致した戻りデータのソート順を保持
                newSortOrder = ret.sortOrder;
                return;
              }
            });
            changeInfo.tgtIdx = index;
            changeInfo.newSortOrder = newSortOrder;
            changeInfoList.push(changeInfo);
            return;
          });
          return;
        }
      });

      // ソート順の書き換え
      changeInfoList.forEach(function (changeInfo) {
        targetAreaSortOrders[changeInfo.tgtIdx].sortOrder = changeInfo.newSortOrder;
      });
      this.handleRegister(targetAreaSortOrders);
    });
    // 並び順の更新処理
    _defineProperty(this, "handleRegister", areaSortOrders => {
      const {
        callAPI,
        setIsReSearch,
        openInfoBar
      } = this.props;
      const sendData = {
        areaSortOrders: areaSortOrders
      };
      let url = _APIs.AREA_ORDERING_REGISTER;
      callAPI(url, sendData).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.INFO, response.message);
          setIsReSearch(true); // 再検索を行うために、isReSearchをtrueに変更する
        } else {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
        }
      });
    });
  }
  componentDidMount() {
    const {
      scrollY,
      noSticky
    } = this.props.scrollTop;
    if (noSticky) {
      _windowUtil.default.windowScroll(scrollY);
    } else {
      window.scrollTo(0, 0);
    }
  }
  render() {
    const {
      intl,
      pms,
      isNewWindow
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.MASTERDATA_AREA_ORDERING_TITLE
      })
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_AreaOrderingSearchCondition.default, {
      pms: pms,
      isNewWindow: isNewWindow
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_AreaOrderingSearchResult.default, {
      onDetailClick: this.onDetailClick,
      onSortUpdate: this.onSortUpdate
    })))));
  }
}
const mapStateToProps = state => {
  return {
    searchConditions: state.areaOrdering.searchConditions,
    searchResult: state.areaOrdering.searchResult,
    paging: state.areaOrdering.paging,
    scrollTop: state.areaOrdering.scrollTop,
    loginUserInfo: state.coreLoginInfo.loginUser[state.coreLocale.language]
  };
};
const mapDispatchToProps = dispatch => {
  return {
    goDetail: kaishaCd => dispatch(_areaOrderingActions.areaOrderingActions[_areaOrderingActions.TYPES.GO_DETAIL](kaishaCd)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    setIsReSearch: isReSearch => dispatch(_areaOrderingActions.areaOrderingActions[_areaOrderingActions.TYPES.SET_IS_RE_SEARCH](isReSearch))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(AreaOrderingMain)));